<template>
  <DsButton
    :variant="variant"
    shape="pill"
    :size="size"
    class="w-full"
    data-test="contact-support"
    @click="openSupport"
  >
    <slot>Contact support</slot>
  </DsButton>
</template>

<script>
import { Button as DsButton } from '@team-hogc/hogc-one-design-system';
import { openCrispChat } from '@/utils/crisp';
import { isNativeNotWeb } from '@/utils/platform-check';

// The Me page waits this long on native before opening Crisp, so the tap's own
// touch does not land on (and close) the chat as it slides in.
export const NATIVE_OPEN_DELAY_MS = 250;

/**
 * Opens the Crisp support chat the way the Me page's Support item does, with the
 * member's details set first so support sees who is asking.
 */
export default {
  name: 'ContactSupportButton',
  components: { DsButton },
  props: {
    variant: { type: String, default: 'bordered' },
    size: { type: String, default: '48' },
  },
  emits: ['open'],
  computed: {
    crispProfileData() {
      const profile = this.$store?.state?.profile;
      if (!profile?.id) return undefined;
      return {
        email: profile.email,
        preferredName: profile.preferredName,
        givenName: profile.givenName,
        id: profile.id,
        cgName: profile.cgName,
        role: profile.role,
      };
    },
  },
  methods: {
    openSupport() {
      this.$emit('open');
      const open = () => openCrispChat({ showFirst: true, profileData: this.crispProfileData });
      if (isNativeNotWeb()) {
        setTimeout(open, NATIVE_OPEN_DELAY_MS);
      } else {
        open();
      }
    },
  },
};
</script>
